/** @format */

import axios from "axios";
import { apiEndpoint } from "../../urls";
import { logUserEvent } from "../logger";

export const pdfToolApi = {
  login: async (username, password) => {
    const page = window.location.pathname;
    const apiName = "login";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { username });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/token/`,
        { username, password }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  refreshToken: async (refresh) => {
    const page = window.location.pathname;
    const apiName = "refreshToken";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { refresh });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/token/refresh/`,
        { refresh }
      );
      sessionStorage.setItem("accessToken", response.data.access);
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  uploadPdf: async (document, access) => {
    const page = window.location.pathname;
    const apiName = "uploadPdf";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { document });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/upload_document/`,
        document,
        {
          headers: { Authorization: `Bearer ${access}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  setTemplate: async (templateData, templateId, token) => {
    const page = window.location.pathname;
    const apiName = "setTemplate";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { templateId, templateData });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/set_template/${templateId}/`,
        { ...templateData },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  getAllDocuments: async (accessToken) => {
    const page = window.location.pathname;
    const apiName = "getAllDocuments";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, {});
      const response = await axios.get(
        `${apiEndpoint.pdfBaseUri}/editor/get_document_details/?source=website`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  getSelectedDocuments: async (accessToken, document_id, request_id) => {
    const page = window.location.pathname;
    const apiName = "getSelectedDocuments";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { document_id });
      const response = await axios.get(
        `${apiEndpoint.pdfBaseUri}/editor/get_document_details/${document_id}/?source=website&request_id=${request_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  deleteSelectedPdf: async (accessToken, document_id) => {
    const page = window.location.pathname;
    const apiName = "delete_document";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { document_id });
      const response = await axios.delete(
        `${apiEndpoint.pdfBaseUri}/editor/delete_document/${document_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  editDocument: async (payload, documentID, token) => {
    const page = window.location.pathname;
    const apiName = "editDocument";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { documentID, payload });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/edit_document/${documentID}/`,
        { ...payload },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  getPDF: async (documentID, key, token) => {
    const page = window.location.pathname;
    const apiName = "getPDF";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { documentID, key });
      const response = await axios.get(
        `${apiEndpoint.pdfBaseUri}/editor/get_document/${documentID}/?key=${key}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  reUploadPdf: async (payload, documentID, token) => {
    const page = window.location.pathname;
    const apiName = "reUploadPdf";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { documentID, payload });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/reupload_document/${documentID}/`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  testGeneratePdf: async (workflowName, documentID, acctoken) => {
    const page = window.location.pathname;
    const apiName = "testGeneratePdf";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { workflowName, documentID });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/preview_pdf/${documentID}/`,
        {},
        {
          headers: { Authorization: `Bearer ${acctoken}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  imageUpload: async (formData, accessToken) => {
    const page = window.location.pathname;
    const apiName = "imageUpload";
    try {
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { formData });
      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/upload_media/`,
        formData,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },

  deleteImage: async (imagePath, accessToken) => {
    const page = window.location.pathname;
    const apiName = "deleteImage";
    try {
      const imageList = Array.isArray(imagePath) ? [...imagePath] : [imagePath];
      logUserEvent("API Request", `Calling API: ${apiName}`, page, { imageList });
      const response = await axios.delete(
        `${apiEndpoint.pdfBaseUri}/editor/delete_image/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          data: { imageUrl: imageList },
        }
      );
      logUserEvent("API Response", `API Success: ${apiName}`, page, { data: response.data });
      return response.data;
    } catch (error) {
      logUserEvent("API Error", `API Error: ${apiName}`, page, { error });
      throw error;
    }
  },
};
